/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Faq_4_QInputs */

const en_control_faq_4_q = /** @type {(inputs: Control_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is Build Power?`)
};

const zh_control_faq_4_q = /** @type {(inputs: Control_Faq_4_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`什么是 Build Power？`)
};

/**
* | output |
* | --- |
* | "What is Build Power?" |
*
* @param {Control_Faq_4_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_faq_4_q = /** @type {((inputs?: Control_Faq_4_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Faq_4_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_faq_4_q(inputs)
	return zh_control_faq_4_q(inputs)
});
export { control_faq_4_q as "control.faq.4.q" }